import './App.css';
import { useState, useEffect } from 'react';
import { Arcalab } from './components/Arcalab';
import { ArcalabInscricao } from './components/inscricao/ArcalabInscricao';
import { Helmet } from 'react-helmet';

function App() {

  const [cupom, setCupom] = useState('')
  const [verifyMail, setVerifyMail] = useState('')
  const [forgotPass, setForgotPass] = useState('')

  useEffect(()=>{
    const cup = (new URLSearchParams(window.location.search)).get('cupom')
    const verify = (new URLSearchParams(window.location.search)).get('verificar')
    const forgot = (new URLSearchParams(window.location.search)).get('forgot')
    if(cup!=null){
      setCupom(cup.toUpperCase())
    }
    if(verify!=null){
      setVerifyMail(verify)
    }
    if(forgot!=null){
      setForgotPass(forgot)
    }
  },[])

  const sc_width = window.innerWidth
  let sc_height = window.innerHeight
  if(sc_height>1200){
    sc_height=1200
  }

  return (
    <div className="App">
      <Helmet>
        <link href="https://vjs.zencdn.net/8.16.1/video-js.css" rel="stylesheet" />
      </Helmet>
      <Arcalab height={sc_height} width={sc_width} cupom={cupom} verifyMail={verifyMail} forgotPass={forgotPass}/>
    </div> 
  );
}

export default App;
